/**
 * @generated SignedSource<<d6ad0ddccc3850cd887ad6784b5e36e4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftMarketLayout_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftMarketGrid_viewer">;
  readonly " $fragmentType": "NftMarketLayout_viewer";
};
export type NftMarketLayout_viewer$key = {
  readonly " $data"?: NftMarketLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftMarketLayout_viewer">;
};

import NftMarketLayoutRefetchQuery_graphql from './NftMarketLayoutRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "auctionMarketTypes"
    },
    {
      "kind": "RootArgument",
      "name": "auctionStatuses"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "itemCount"
    },
    {
      "kind": "RootArgument",
      "name": "mediumTypes"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "search"
    },
    {
      "kind": "RootArgument",
      "name": "sortBy"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": NftMarketLayoutRefetchQuery_graphql
    }
  },
  "name": "NftMarketLayout_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "auctionMarketTypes",
          "variableName": "auctionMarketTypes"
        },
        {
          "kind": "Variable",
          "name": "auctionStatuses",
          "variableName": "auctionStatuses"
        },
        {
          "kind": "Variable",
          "name": "mediumTypes",
          "variableName": "mediumTypes"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        },
        {
          "kind": "Variable",
          "name": "sortBy",
          "variableName": "sortBy"
        }
      ],
      "kind": "FragmentSpread",
      "name": "NftMarketGrid_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "56d572d1f2cf80842b9b83256e9be69b";

export default node;
